import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { useFormContext, get } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import "./select.scss";

type SelectOptionValue = {
  value: string | number;
  label: string;
  key?: string;
  disabled?: boolean;
};

type SelectProps = {
  isFormElement?: boolean;
  options: SelectOptionValue[];
  children?: React.ReactNode;
  required?: boolean;
  name: string;
  onChange?: Function;
  disabled?: boolean;
  defaultValue?: string;
  eventContext?: string;
  eventName?: string;
  style?: React.CSSProperties;
};

const Select: React.FC<SelectProps> = function ({
  isFormElement,
  children,
  name,
  required,
  options,
  disabled,
  defaultValue,
  onChange,
  eventContext: _eventContext,
  eventName: _eventName,
  style,
  ...props
}) {
  const {
    register,
    getValues,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  const hasError = required && get(errors, name);

  if (!getValues(name) && defaultValue && name) setValue(name, defaultValue);

  function onValueChange(e: React.ChangeEvent<HTMLSelectElement>) {
    setValue(name, e.currentTarget.value);
    trigger(name);
  }

  return (
    <div className="select position-relative bg-white br-5 w-100" id={name}>
      <Form.Control
        as="select"
        className={`pt-10 pb-10 pl-14 pr-14 height-auto ${isFormElement ? "" : ""} ${
          hasError ? "invalid-input" : "form-control"
        } `}
        custom
        style={style}
        value={getValues(name)}
        {...register(name, { required })}
        {...props}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          if (onChange) onChange(e);
          onValueChange(e);
        }}
        disabled={disabled}
        name={name}
      >
        {options.map(({ value, label, key, disabled }) => (
          <option
            key={Math.random()}
            value={name === "pickup_state" || name === "stop1_state" ? label : value}
            disabled={disabled || false}
          >
            {label || key}
          </option>
        ))}
      </Form.Control>

      {required
        ? get(errors, name) &&
          name !== "payment_locations" && (
            <div className="d-block font-b3 invalid-feedback">
              <FormattedMessage id="general.requiredField" defaultMessage="This is a required field" />
            </div>
          )
        : null}
      {children && getValues(name) !== "no" ? children : null}
    </div>
  );
};

Select.propTypes = {
  isFormElement: PropTypes.bool,
  // options: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  children: PropTypes.node,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  eventContext: PropTypes.string,
  eventName: PropTypes.string,
  style: PropTypes.instanceOf(Object),
};

Select.defaultProps = {
  isFormElement: false,
  children: null,
  required: false,
  onChange: () => {},
  disabled: false,
  defaultValue: "",
  eventContext: "Quote Request Form",
  eventName: "",
  style: {},
};

export default Select;
